/**
 * U.S. state consumer data privacy laws disclosed in the Privacy Policy.
 * California is covered in its own section, so it is not repeated here.
 */
export interface StatePrivacyLaw {
  state: string
  law: string
  effective: string
  /** Rights or disclosures specific to this state, beyond the common set. */
  notes?: string
}

export const statePrivacyLaws: StatePrivacyLaw[] = [
  {
    state: 'Colorado',
    law: 'Colorado Privacy Act',
    effective: 'July 1, 2023',
    notes: 'Universal opt-out signals (e.g., Global Privacy Control) honored.',
  },
  {
    state: 'Connecticut',
    law: 'Connecticut Data Privacy Act',
    effective: 'July 1, 2023',
    notes: 'Universal opt-out signals honored.',
  },
  {
    state: 'Delaware',
    law: 'Delaware Personal Data Privacy Act',
    effective: 'January 1, 2025',
    notes:
      'Right to obtain a list of the categories of third parties to which personal data was disclosed.',
  },
  {
    state: 'Indiana',
    law: 'Indiana Consumer Data Protection Act',
    effective: 'January 1, 2026',
  },
  {
    state: 'Iowa',
    law: 'Iowa Consumer Data Protection Act',
    effective: 'January 1, 2025',
  },
  {
    state: 'Kentucky',
    law: 'Kentucky Consumer Data Protection Act',
    effective: 'January 1, 2026',
  },
  {
    state: 'Maryland',
    law: 'Maryland Online Data Privacy Act',
    effective: 'October 1, 2025',
    notes:
      'Right to obtain a list of the categories of third parties to which personal data was disclosed.',
  },
  {
    state: 'Minnesota',
    law: 'Minnesota Consumer Data Privacy Act',
    effective: 'July 31, 2025',
    notes:
      'Right to obtain a list of the specific third parties to which personal data was disclosed, and to question the result of any profiling decision.',
  },
  {
    state: 'Montana',
    law: 'Montana Consumer Data Privacy Act',
    effective: 'October 1, 2024',
    notes: 'Universal opt-out signals honored.',
  },
  {
    state: 'Nebraska',
    law: 'Nebraska Data Privacy Act',
    effective: 'January 1, 2025',
  },
  {
    state: 'Nevada',
    law: 'Nevada Revised Statutes Chapter 603A',
    effective: 'October 1, 2021',
    notes:
      'Right to opt out of the sale of covered information collected through this website.',
  },
  {
    state: 'New Hampshire',
    law: 'New Hampshire Privacy Act (RSA 507-H)',
    effective: 'January 1, 2025',
    notes: 'Universal opt-out signals honored.',
  },
  {
    state: 'New Jersey',
    law: 'New Jersey Data Privacy Act',
    effective: 'January 15, 2025',
    notes: 'Universal opt-out signals honored.',
  },
  {
    state: 'Oregon',
    law: 'Oregon Consumer Privacy Act',
    effective: 'July 1, 2024',
    notes:
      'Right to obtain a list of the specific third parties to which personal data was disclosed.',
  },
  {
    state: 'Rhode Island',
    law: 'Rhode Island Data Transparency and Privacy Protection Act',
    effective: 'January 1, 2026',
  },
  {
    state: 'Tennessee',
    law: 'Tennessee Information Protection Act',
    effective: 'July 1, 2025',
  },
  {
    state: 'Texas',
    law: 'Texas Data Privacy and Security Act',
    effective: 'July 1, 2024',
    notes: 'Universal opt-out signals honored.',
  },
  {
    state: 'Utah',
    law: 'Utah Consumer Privacy Act',
    effective: 'December 31, 2023',
  },
  {
    state: 'Virginia',
    law: 'Virginia Consumer Data Protection Act',
    effective: 'January 1, 2023',
  },
]

/** Request types offered on the privacy request form. */
export const privacyRequestTypes = [
  { value: 'opt-out', label: 'Opt out of sale, sharing, or targeted advertising' },
  { value: 'access', label: 'Access / confirm the personal data you hold' },
  { value: 'portability', label: 'Get a portable copy of my data' },
  { value: 'correct', label: 'Correct inaccurate data' },
  { value: 'delete', label: 'Delete my data' },
  { value: 'third-parties', label: 'List of third parties my data was disclosed to' },
  { value: 'appeal', label: 'Appeal a decision on a previous request' },
]

/** Every U.S. state plus D.C., for the state-of-residence field. */
export const usStates = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
]
